/* Do not change this file. */

import { createApp } from "vue";
import App from "./App.vue";
import axios from "axios";
import router from "./router";
import store from "@/store";

import "bootstrap/dist/css/bootstrap.css";
//import "@osuecampus/bootstrap-osu/dist/css/bootstrap.css";

import "bootstrap-icons/font/bootstrap-icons.css";

import "@/css/style.css";

import focus from "@/directives/focus";

import CustomAlert from "@/components/ui/CustomAlert.vue";

const app = createApp(App).use(store).use(router).directive("focus", focus);
app.component("CustomAlert", CustomAlert);

app.config.globalProperties.axios = axios;

app.mount("#app");
